import axios from 'axios';
import { CompanyDetails, DunsNumber, EntitlementsResponse } from '@customTypes/ItemTypes';
import { sendGA4ClickEvent } from '@helpers/gtmUtils';
import { PRODUCT_DETAILS_CONSTANTS } from '@helpers/constants';

const { NavigateCredit } = PRODUCT_DETAILS_CONSTANTS;

export function getCompanyDetails(dunsNumber: DunsNumber, idaas_uuid?: string, type?: string): Promise<CompanyDetails> {
    const idaas_uuid_param = idaas_uuid ? `&idaas_uuid=${idaas_uuid}` : '';
    const dunsType = type ? `&type=${type}` : '';
    return axios.get(`/services/entitlements/getCompanyInfo?dunsNumber=${dunsNumber}${idaas_uuid_param}${dunsType}`)
        .then((response) => {
            if (response.status !== 200) {
                sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Unable to load company profile URL' });
            }
            return response.data;
        })
        .catch((err) => {
            console.log(err.message);
        });
}

export function getAllEntitlements(): Promise<EntitlementsResponse> {
    return axios.get('/services/entitlements/all')
        .then((response) => response.data);
}

export function getAssignedEntitlements(): Promise<EntitlementsResponse> {
    return axios.get('/services/entitlements/assigned')
        .then((response) => response.data);
}

export function getEntitlementsAgainstDuns(duns: string): Promise<EntitlementsResponse> {
    return axios.post('/services/entitlements/get-entitlements-by-duns', { dunsArray: [duns] })
        .then((response) => response.data);
}

export function getLegalEntitlements(): Promise<EntitlementsResponse> {
    return axios.get('/services/entitlements/legal-terms')
        .then((response) => response.data);
}

export async function getNavigateUrl(
    dunsNumber: number | string,
    DUNSList: Array<number | string>,
    noDunsFlow = false,
    pendingDuns = false
): Promise<any> {
    try {
        const reqData = {
            applicationId: NavigateCredit?.appId, dunsNumber, DUNSList, noDunsFlow, pendingDuns
        };
        const navigateUrlResp = await axios.post('/services/entitlements/getNavigateUrl', reqData);
        return navigateUrlResp.data;
    }
    catch (err) {
        console.log('ERROR with call to getNavigateUrl: ', err);
    }
}
